import __var_0__ from './main.js';
/**

*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Round a single-precision floating-point number toward negative infinity.
*
* @module @stdlib/math/base/special/floorf
*
* @example
* var floorf = require( '@stdlib/math/base/special/floorf' );
*
* var v = floorf( -4.2 );
* // returns -5.0
*
* v = floorf( 9.99999 );
* // returns 9.0
*
* v = floorf( 0.0 );
* // returns 0.0
*
* v = floorf( NaN );
* // returns NaN
*/

// MODULES //
var floorf = __var_0__;


// EXPORTS //
export default floorf;
